import { render, staticRenderFns } from "./SiderRouteInsurance.vue?vue&type=template&id=41d3f298&scoped=true&"
import script from "./SiderRouteInsurance.vue?vue&type=script&lang=js&"
export * from "./SiderRouteInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d3f298",
  null
  
)

export default component.exports